import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Grid, Popup, Button, Icon, Dropdown} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

const INITIAL_STATE = {
  'isOpen': false,
  'newFranchise': '',
};

class ChangeFranchiseModal extends Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
  }

  parseFranchisees = () => {
    const {franchisees, franchise} = this.props;
    return franchisees.filter((element) =>
      (element.code !== franchise)).map((item, index) => ({
      'key': index,
      'text': `${item.code} - ${item.name}`,
      'value': item.code,
    }));
  }

  handleOpenClick = (event) => {
    event.preventDefault();
    this.props.getFranchiseesList();
    this.setState({'isOpen': true});
  };

  handleCloseClick = () => {
    this.setState(INITIAL_STATE);
  }

  handleSaveClick = () => {
    const {newFranchise} = this.state;
    const {partCode, franchise, company} = this.props;

    if (newFranchise) {
      const data = {
        company,
        partCode,
        franchise,
        newFranchise,
      };
      this.props.updatePartFranchise(data);
    }
    this.handleCloseClick();
  }

  handleFieldChange = (event, {name, value}) => {
    this.setState({[name]: value.toUpperCase()});
  }

  renderTrigger() {
    return (
      <Popup
        inverted
        position="top center"
        content="Cambio de franquicia"
        trigger={<Icon name="add" color="red" onClick={this.handleOpenClick} />}
      />
    );
  }

  render() {
    const {isOpen, newFranchise} = this.state;
    const {loadingFranchisees} = this.props;

    return (
      <Modal
        className="franchise-modal"
        open={isOpen}
        trigger={this.renderTrigger()}
        size='mini'
      >
        <Modal.Header>Cambio de franquicia</Modal.Header>
        <Modal.Content>
          <Grid padded>
            <Grid.Row>
              <Grid.Column>
                <label>
                  <strong>Seleccione la nueva franquicia</strong>
                </label>
                <Dropdown
                  fluid
                  selection
                  search
                  name="newFranchise"
                  value={newFranchise}
                  loading={loadingFranchisees}
                  options={this.parseFranchisees()}
                  onChange={this.handleFieldChange}
                  error={!newFranchise}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={this.handleCloseClick}>
            Cancelar
          </Button>
          <Button primary disabled={!newFranchise} onClick={this.handleSaveClick}>
            Guardar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'franchise': state.partsMaster.values.franchise,
    'loadingFranchisees': state.partsMaster.loadingFranchisees,
    'franchisees': state.partsMaster.franchisees,
  };
};

const {updatePartFranchise, getFranchiseesList} = Actions;

export default connect(mapStateToProps, {updatePartFranchise, getFranchiseesList})(
  ChangeFranchiseModal
);
